<div class="msg-info">
  <i class="pi pi-info-circle pr-1"></i>
  <div class="pl-2">
    @if (title) {
      <p class="msg-info-title">{{ title }}</p>
    }
    <ng-content></ng-content>
  </div>
</div>
